import React from 'react';
import ReactDOM from 'react-dom/client';
import TruePour from './App';
import { register } from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <TruePour />
  </React.StrictMode>
);

register();
